module.exports = __webpack_public_path__ + "static/media/welcome_bg.7b5d7983.png";